import {action, makeAutoObservable} from "mobx";
import {PageEntity} from "../entity/page-entity";
import {DetailType} from "../common/Constant";
import {AtlasEntity} from "../entity/atlas-entity";
import {getManagerAtlasInfoList} from "../http/manager";
import {RcFile} from "antd/es/upload";
import {getAtlasInfoList} from "../http/home";

export class ImageLibraryStore {

    constructor() {
        makeAutoObservable(this)
    }

    public condition = this.getDefaultCondition();
    public isShowDetail = false;
    public isShowUpload = false;
    public index: number = 0;
    public pagination: PageEntity = new PageEntity();
    public isShowEdit = false;
    public isShowDeleteConfirm = false;
    public dataSource: AtlasEntity[] = [];
    public detailType: string = DetailType.ADD;
    public detailEntity: AtlasEntity|undefined;
    public deleteRecord: AtlasEntity|undefined;
    public srcFile: any;
    public fileList: RcFile[] = [];

    public isFrontDetailOpen =  false
    public frontDetailEntity: AtlasEntity|undefined
    public frontDataSource: AtlasEntity[]|undefined
    public isFrontExpend = false
    public frontCondition = this.getDefaultCondition()
    public frontPagination:PageEntity = new PageEntity()

    public setShowDetail(isShow: boolean) {
        this.isShowDetail = isShow;
    }

    public setShowUpload(isUpload: boolean) {
        this.isShowUpload = isUpload;
    }

    public setShowEdit(isEdit: boolean) {
        this.isShowEdit = isEdit;
    }

    public showDeleteConfirm(isShow: boolean) {
        this.isShowDeleteConfirm = isShow;
    }

    public setDetailType (type:string) {
        this.detailType = type;
    }

    getDefaultCondition() {
        return {
            atlasNumber: "", // 图谱编号
            sampleNumber: "", // 采样编号
            originalPlant: "", // 基原植物
            latinName: "", // 拉丁名
            appraiser: "", //鉴定人
            atlasType: "", // 图谱类型
            medicineName: "", // 药材名
            pageSize: 10,
            pageNum: 1
        };
    }

    public reset() {
        this.condition = this.getDefaultCondition()
        this.pagination = new PageEntity()
    }

    public requestAtlasInfoList(params: {}) {
        getManagerAtlasInfoList(params)
            .then((res) => {
                this.dataSource = res.data ? res.data.list : []
                this.pagination.total = res.data ? res.data.total : 0
            })
    }

    public setFilelist(file:RcFile) {
        this.fileList = [];
        this.fileList.push(file);
    }
    public clearFileList = () =>  {
        this.fileList = [];
    }

    public getAtlasList(params:{}) {
        getAtlasInfoList(params)
            .then((res) => {
                if (res && res.data) {
                    console.log("dtl----", res.data)
                    this.frontPagination.total = res.data.total ? res.data.total : 0
                    this.frontDataSource = res.data.list ? res.data.list : []
                } else {
                    this.frontPagination.total = 0
                    this.frontDataSource = []
                }
            }).catch((e) => {
            console.log("error:" + e.message)
        })
    }

    public onFrontReset() {
        this.frontCondition = this.getDefaultCondition()
    }

    clear() {
        this.condition = this.getDefaultCondition()
        this.isShowDetail = false
        this.isShowUpload = false
        this.isShowEdit = false
        this.isShowDeleteConfirm = false
        this.index = 0
        this.pagination = new PageEntity()
        this.dataSource = []
        this.detailType = DetailType.ADD
        this.srcFile = null
        this.fileList = []
    }

    frontClear() {
        this.frontCondition = this.getDefaultCondition()
        this.frontPagination = new PageEntity()
        this.isFrontDetailOpen = false
        this.isFrontExpend = false
        this.frontDataSource = []
        this.frontDetailEntity = undefined
    }

}